<div class="new-priority-page">
  <!-- First Section: Background Image Cover -->
  <div class="hero-dashboard-section">
    <!-- Hero Header -->
    <div class="hero-section">
      <h1 class="main-title">Uncover the <br class="web-hide" > hidden gaps in your</h1>
      <div class="title-rotator-wrapper">
        <div class="title-rotator-list" [style.transform]="'translateY(' + (currentPortfolioIndex * -100) + '%)'"
          [style.transition]="isRotatorTransition ? 'transform 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94)' : 'none'">
          <div class="rotator-item" *ngFor="let type of portfolioTypes">{{type}}</div>
        </div>
      </div>
      <p class="subtitle">
        Get a detailed expert review from <br class="web-hide"> <strong>Bajaj Capital</strong><br class="mb-hide">
        to understand performance, risk, and future potential
      </p>

      <button class="cta-btn" (click)="openLeadModal()">
        Get a FREE Portfolio Review <span class="arrow">&gt;</span>
      </button>
    </div>
    <!-- Interactive Dashboard Card -->
    <div class="dashboard-card" (click)="openLeadModal()">
      <!-- Left Column: Portfolio Health Score -->
      <div class="health-score-col">
        <h3 class="card-title">Portfolio Health Score</h3>
        <div class="score-display">
          <div class="score-number-box">
            <span class="score-num">{{healthScore}}</span>
            <span class="score-total">/100</span>
          </div>
          <div class="graph-wrapper">
            <img src="assets/images/new-priority/PieGraphChart.png" alt="Portfolio Health Chart" class="progress-image">
          </div>
        </div>
        <div class="badge-row">
          <div class="review-badge">
            <img class="review-badge-icon" src="../../../../../assets/images/new-priority/Tick.svg" alt="tick" />
            Needs Expert Review
          </div>
        </div>
      </div>

      <!-- Right Column: Risk Score & Asset Allocation -->
      <div class="risk-allocation-col">
        <!-- Risk Score Widget -->
        <div class="metric-widget risk-widget">
          <div class="widget-info">
            <h4>Risk Score</h4>
            <span class="widget-value risk-medium">Medium</span>
          </div>
          <div class="widget-chart">
            <svg viewBox="0 0 100 60" class="gauge-svg">
              <!-- Red segment -->
              <path d="M 15 50 A 35 35 0 0 1 85 50" fill="none" stroke="#E52929" stroke-width="18"
                stroke-dasharray="21.03 88.93" stroke-dashoffset="0" />
              <!-- Orange segment -->
              <path d="M 15 50 A 35 35 0 0 1 85 50" fill="none" stroke="#F28D35" stroke-width="18"
                stroke-dasharray="21.03 88.93" stroke-dashoffset="-22.23" />
              <!-- Yellow segment -->
              <path d="M 15 50 A 35 35 0 0 1 85 50" fill="none" stroke="#F2D022" stroke-width="18"
                stroke-dasharray="21.03 88.93" stroke-dashoffset="-44.46" />
              <!-- Light Green segment -->
              <path d="M 15 50 A 35 35 0 0 1 85 50" fill="none" stroke="#8CC63F" stroke-width="18"
                stroke-dasharray="21.03 88.93" stroke-dashoffset="-66.69" />
              <!-- Dark Green segment -->
              <path d="M 15 50 A 35 35 0 0 1 85 50" fill="none" stroke="#22B14C" stroke-width="18"
                stroke-dasharray="21.03 88.93" stroke-dashoffset="-88.92" />

              <!-- Needle pointer -->
              <line class="gauge-needle" [class.animate]="isAnimated" x1="50" y1="50" x2="25" y2="50" stroke="#1B1B1C"
                stroke-width="3.5" stroke-linecap="round" />
              <circle cx="50" cy="50" r="4.5" fill="#1B1B1C" />
            </svg>
          </div>
        </div>

        <!-- Asset Allocation Widget -->
        <div class="metric-widget allocation-widget">
          <div class="widget-info">
            <h4>Asset Allocation</h4>
            <div class="legend-container">
              <div class="legend-row">
                <span class="legend-dot equity-dot"></span>
                <span class="legend-text">Equity: <span class="legend-val">65%</span></span>
              </div>
              <div class="legend-row">
                <span class="legend-dot debt-dot"></span>
                <span class="legend-text">Debt: <span class="legend-val">25%</span></span>
              </div>
              <div class="legend-row">
                <span class="legend-dot cash-dot"></span>
                <span class="legend-text">Cash: <span class="legend-val">10%</span></span>
              </div>
            </div>
          </div>
          <div class="widget-chart">
            <svg viewBox="0 0 80 80" class="donut-svg">
              <!-- Cash Segment (Grey) -->
              <circle class="donut-segment donut-cash" [class.animate]="isAnimated" cx="40" cy="40" r="28" fill="none"
                stroke="#D6D6D6" stroke-width="14" transform="rotate(-90 40 40)" />
              <!-- Debt Segment (Coral) -->
              <circle class="donut-segment donut-debt" [class.animate]="isAnimated" cx="40" cy="40" r="28" fill="none"
                stroke="#ED6C6C" stroke-width="14" transform="rotate(-51.86 40 40)" />
              <!-- Equity Segment (Red) -->
              <circle class="donut-segment donut-equity" [class.animate]="isAnimated" cx="40" cy="40" r="28" fill="none"
                stroke="#D11A2A" stroke-width="14" transform="rotate(38.91 40 40)" />
            </svg>
          </div>
        </div>
      </div>
    </div>

    <!-- Trust Stats Banner -->
    <div class="stats-banner">
      <!-- Item 1 -->
      <div class="stat-item">
        <div class="stat-icon-box">
          <img src="assets/images/new-priority/trust-expertise.svg" alt="60+ Years of financial expertise icon"
            class="stat-icon" />
        </div>
        <div class="stat-text-box">
          <span class="stat-value">60+ Years</span>
          <span class="stat-label">OF FINANCIAL EXPERTISE</span>
        </div>
      </div>

      <div class="stat-divider"></div>

      <!-- Item 2 -->
      <div class="stat-item">
        <div class="stat-icon-box">
          <img src="assets/images/new-priority/trust-customers.svg" alt="4.1 Million+ customers served icon"
            class="stat-icon" />
        </div>
        <div class="stat-text-box">
          <span class="stat-value">4.1 Million+</span>
          <span class="stat-label">CUSTOMERS SERVED</span>
        </div>
      </div>

      <div class="stat-divider"></div>

      <!-- Item 3 -->
      <div class="stat-item">
        <div class="stat-icon-box">
          <img src="assets/images/new-priority/trust-branches.svg" alt="110+ branches icon" class="stat-icon" />
        </div>
        <div class="stat-text-box">
          <span class="stat-value">110+ Branches</span>
          <span class="stat-label">ACROSS INDIA</span>
        </div>
      </div>

      <div class="stat-divider"></div>

      <!-- Item 4 -->
      <div class="stat-item">
        <div class="stat-icon-box">
          <img src="assets/images/new-priority/trust-advice.svg" alt="Personalized financial advice icon"
            class="stat-icon" />
        </div>
        <div class="stat-text-box">
          <span class="stat-value">Personalized</span>
          <span class="stat-label">FINANCIAL ADVICE</span>
        </div>
      </div>

      <div class="stat-divider"></div>

      <!-- Item 5 -->
      <div class="stat-item">
        <div class="stat-icon-box">
          <img src="assets/images/new-priority/trust-partner.svg" alt="One partner icon" class="stat-icon" />
        </div>
        <div class="stat-text-box">
          <span class="stat-value">One Partner</span>
          <span class="stat-label">FOR ALL YOUR FINANCIAL NEEDS</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Second Section: Is Your Investment Portfolio Really Working? -->
  <section class="portfolio-check-section">
    <h2 class="check-section-title">Is Your Investment Portfolio Really <span class="highlight-italic">Working?</span>
    </h2>

    <div class="cards-grid">
      <!-- Card 1: Underperformance Check -->
      <div class="check-card">
        <div class="card-icon-wrapper outline-red">
          <img src="assets/images/new-priority/check-underperformance.svg" alt="Underperformance check icon"
            class="check-icon" />
        </div>
        <h3>Underperformance <br> Check</h3>
        <p>Discover whether your investments are delivering their true potential or quietly holding back your wealth
          creation journey.</p>
      </div>

      <!-- Card 2: Risk Balance Check -->
      <div class="check-card">
        <div class="card-icon-wrapper outline-red">
          <img src="assets/images/new-priority/check-risk.svg" alt="Risk balance check icon" class="check-icon" />
        </div>
        <h3>Risk Balance <br> Check</h3>
        <p>Find out if your portfolio carries the right level of risk or if hidden imbalances could impact your
          long-term financial goals.</p>
      </div>

      <!-- Card 3: Goal Alignment Check -->
      <div class="check-card">
        <div class="card-icon-wrapper outline-red">
          <img src="assets/images/new-priority/check-goal.svg" alt="Goal alignment check icon" class="check-icon" />
        </div>
        <h3>Goal Alignment <br> Check</h3>
        <p>Ensure every investment is working towards your life goals not just generating returns but helping you
          achieve them on time.</p>
      </div>
    </div>

    <!-- Red outlined CTA button -->
    <div class="section-cta-row">
      <button class="cta-btn-outline" (click)="openLeadModal()">
        Get a FREE Portfolio Review <span class="arrow">&gt;</span>
      </button>
    </div>
  </section>

  <!-- Advantage Section -->
  <section class="advantage-section">
    <h2 class="advantage-title">The Bajaj Capital Portfolio Review <span class="highlight-italic">Advantage!</span></h2>
    <p class="advantage-subtitle">
      Backed by <strong class="red-text">60+ years of trust</strong>, Bajaj Capital helps investors make smarter, <br class="mb-hide">
      goal-based investment decisions.
    </p>

    <div class="advantage-container">
      <!-- Row 1: 3 columns -->
      <div class="advantage-row row-3-cols">
        <!-- Item 1 -->
        <div class="advantage-item">
          <div class="advantage-icon-box">
            <img src="assets/images/new-priority/adv-research.svg" alt="Research driven insights icon"
              class="advantage-icon" />
          </div>
          <div class="advantage-text">Research Driven<br>Investment Insights</div>
        </div>
        <!-- Item 2 -->
        <div class="advantage-item">
          <div class="advantage-icon-box">
            <img src="assets/images/new-priority/adv-goal.svg" alt="Goal based mapping icon" class="advantage-icon" />
          </div>
          <div class="advantage-text">Goal-based<br>Investment Mapping</div>
        </div>
        <!-- Item 3 -->
        <div class="advantage-item">
          <div class="advantage-icon-box">
            <img src="assets/images/new-priority/adv-allocation.svg" alt="Asset allocation icon"
              class="advantage-icon" />
          </div>
          <div class="advantage-text">Asset Allocation<br>&amp; Risk Assessment Analysis</div>
        </div>
      </div>

      <!-- Row 2: 2 columns -->
      <div class="advantage-row row-2-cols">
        <!-- Item 4 -->
        <div class="advantage-item">
          <div class="advantage-icon-box">
            <img src="assets/images/new-priority/adv-mutual.svg" alt="Performance review icon" class="advantage-icon" />
          </div>
          <div class="advantage-text">Mutual Fund &amp;<br>SIP Performance Review</div>
        </div>
        <!-- Item 5 -->
        <div class="advantage-item">
          <div class="advantage-icon-box">
            <img src="assets/images/new-priority/adv-rebalance.svg" alt="Rebalancing icon" class="advantage-icon" />
          </div>
          <div class="advantage-text">Portfolio Rebalancing<br>as per your investment goals</div>
        </div>
      </div>
    </div>
  </section>

  <!-- Disclaimer Section with Overlay Card -->
  <section class="disclaimer-section">
    <!-- Overlay Card -->
    <div class="ds-card">
      <div class="disclaimer-card" (click)="openLeadModal()">
        <div class="disclaimer-card-content">
          <h3 class="card-hero-text">Don't Let Your Investments</h3>
          <h2 class="card-hero-highlight">Drift Away From Your Goals</h2>
          <p class="card-hero-sub">Get a <span class="highlight-yellow">FREE</span> Portfolio Review Today!</p>
          <button class="card-cta-btn" (click)="openLeadModal()">
            Book a FREE Review <span class="arrow">&gt;</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Red Wavy Background Content -->
    <div class="disclaimer-content-wrapper">
      <div class="footer-link">
        <a href="https://www.bajajcapital.com" target="_blank">www.bajajcapital.com</a>
      </div>
      <p class="terms">
        Disclaimer: Bajaj Capital Limited [(“BCL”) CIN: U67120DL1965PLC004338] having its registered office at Mezzanine
        Floor 97 Bajaj House, Nehru Place, New Delhi DL, 110019 is a mutual fund distributor (ARN 0010) registered with
        AMFI. Certain products and services offered by BCL may not be traded on the exchange. All disputes with respect
        to the distribution activity, would not have access to Exchange Investor Redressal Forum or Arbitration
        mechanism. In accordance with the applicable laws, BCL is allowed to render incidental advice with respect to
        mutual fund products only to its mutual fund distribution clients. For every other purpose, including
        distribution of non-mutual fund products, the circulated material is for informational purposes only. Further,
        it is not intended as investment advice or an opinion concerning securities or a public offer proving a basis
        for an investment decision. The views or expressions contained in the circulated material are not necessarily of
        BCL and BCL neither assumes any responsibility/ liability nor does guarantee its accuracy, suitability,
        completeness and adequacy. The content of the material including images, charts, graphics and pictures are
        protected intellectual properties and cannot be amended, copied, reproduced, replicated, republished, uploaded,
        posted, published, transmitted, displayed or distributed for any non-personal use without obtaining prior
        written permission, any non-adherence of which may attract appropriate legal action. Mutual Fund investments are
        subject to market risk, read all scheme-related documents carefully. The past performance of the scheme is not
        indicative of future performance. Investors are advised to seek appropriate advice from experts before taking
        any investment decisions. Nothing in the circulated material is intended to construe an advertisement or an
        investment, financial advice and/or solicitation, advice to buy, sell or deal in any financial product.
      </p>
    </div>
  </section>

  <!-- Sleek Modal for Lead Capture -->
  <div class="modal-overlay" *ngIf="isModalVisible" (click)="closeLeadModal()">
    <div class="modal-card" (click)="$event.stopPropagation()">
      <button class="close-button" (click)="closeLeadModal()">&times;</button>

      <!-- Lead Form Screen -->
      <div *ngIf="isLeadFormVisible" class="lead-form-screen">
        <h3 class="modal-heading">Book Your FREE Consultation</h3>
        <p class="modal-subheading">Complete the form below and a Bajaj Capital Expert will contact you shortly.</p>

        <form #newPriorityForm="ngForm" (ngSubmit)="PostData(newPriorityForm)">
          <div class="form-grid">
            <!-- Row 1: Full Name + Age -->
            <div class="form-group name-group">
              <label for="name">Full Name*</label>
              <input type="text" autocomplete="off" id="name" name="name" [(ngModel)]="name"
                class="form-control name-control" (blur)="removeErrorMsg('name')" placeholder="Enter your name"
                maxlength="40" (keydown)="alphaOnly($event)">
              <div class="errormsg" id="name-length-err" *ngIf="nameValidateMessage === 'lengthError'">
                Invalid name
              </div>
              <div class="errormsg" id="name-req-err" *ngIf="nameValidateMessage === 'required'">
                Name is mandatory
              </div>
            </div>

            <div class="form-group age-group">
              <label for="age">Age*</label>
              <input type="text" autocomplete="off" id="age" name="age" [(ngModel)]="age"
                class="form-control age-control" (blur)="removeErrorMsg('age')" placeholder="Enter your age"
                maxlength="3" (keypress)="numberspincode($event)">
              <div class="errormsg" id="age-req-err" *ngIf="ageValidateMessage === 'required'">
                Age is mandatory
              </div>
            </div>

            <!-- Row 2: City + Mobile Number -->
            <div class="form-group city-group">
              <label for="city">City*</label>
              <input type="text" autocomplete="off" id="city" name="city" [(ngModel)]="city"
                class="form-control city-control" (blur)="removeErrorMsg('city')" placeholder="Your current city"
                maxlength="40" (keydown)="alphaOnly($event)">
              <div class="errormsg" id="city-req-err" *ngIf="cityValidateMessage === 'required'">
                City is mandatory
              </div>
            </div>

            <div class="form-group mobile-group">
              <label for="mobile">Mobile Number*</label>
              <input type="text" (keydown.space)="$event.preventDefault()" autocomplete="off" id="mobile" name="mobile"
                [(ngModel)]="mobile" class="form-control mobile-control" placeholder="Enter 10-digit mobile"
                minlength="10" maxlength="10" (blur)="removeErrorMsg('mobile')" (keypress)="numbersOnly($event)">
              <div class="errormsg" id="mobile-length-err" *ngIf="mobileValidateMessage === 'lengthError'">
                10 digit mobile number is mandatory
              </div>
              <div class="errormsg" id="mobile-inv-err" *ngIf="mobileValidateMessage === 'invalid'">
                Invalid mobile number
              </div>
              <div class="errormsg" id="mobile-req-err" *ngIf="mobileValidateMessage === 'required'">
                Mobile number is mandatory
              </div>
            </div>

            <!-- Row 3: Portfolio Size (full width) -->
            <div class="form-group form-group-full portfolio-group">
              <label for="portfolioSize">Current Portfolio Size*</label>
              <select class="form-control portfolio-control" (blur)="removeErrorMsg('portfolioSize')"
                [(ngModel)]="portfolioSize" name="portfolioSize" id="portfolioSize">
                <option value="" disabled selected>Select Range</option>
                <option value="Below 5 Lakhs">Below 5 Lakhs</option>
                <option value="5-10 Lakhs">5-10 Lakhs</option>
                <option value="10-25 Lakhs">10-25 Lakhs</option>
                <option value="25-50 Lakhs">25-50 Lakhs</option>
                <option value="50 Lakhs - 1 Crore">50 Lakhs - 1 Crore</option>
                <option value="1 Crore+">1 Crore+</option>
              </select>
              <div class="errormsg" id="port-req-err" *ngIf="portfolioSizeValidateMessage === 'required'">
                Portfolio size is mandatory
              </div>
            </div>
          </div>

          <button type="submit" class="submit-button submit-consultation-btn">Schedule My Portfolio Review</button>
        </form>
      </div>

      <!-- OTP Verification Screen -->
      <div *ngIf="isOtpFormVisible" class="otp-verification-screen">
        <h3 class="modal-heading">Verify Mobile</h3>
        <p class="modal-subheading">We have sent an OTP to your mobile ending with {{mobile ? mobile.substring(6) : ''}}
        </p>

        <form #verificationOtpForm="ngForm" (ngSubmit)="SubmitOTP(verificationOtpForm)">
          <div class="form-group code-group">
            <input type="text" autocomplete="off" (keydown.space)="$event.preventDefault()" id="otp" name="otp"
              [(ngModel)]="userOTP" class="form-control text-center code-input-field" maxlength="6"
              placeholder="Enter 6-Digit OTP" (keypress)="numberspincode($event)" (keyup)="removeErrorMsg('otp')">
            <div class="errormsg" id="otp-req-err" *ngIf="otpValidateMessage === 'required'">
              OTP is required
            </div>
            <div class="errormsg" id="otp-len-err" *ngIf="otpValidateMessage === 'lengthError'">
              OTP must be 6 digits
            </div>
            <div class="errormsg" id="otp-ver-err" *ngIf="!otpVerifiedStatus">
              Invalid OTP, please try again
            </div>
          </div>

          <div class="otp-actions query-actions">
            <span *ngIf="isTimer" class="timer-text countdown-text">Didn't receive OTP? Resend in
              <strong>{{timeleft}}s</strong></span>
            <a class="resend-link resend-otp-trigger" href="javascript:void(0)" *ngIf="isResend"
              (click)="resendOTP()">Resend OTP</a>
            <a class="change-num change-mobile-trigger" href="javascript:void(0)" (click)="changeNumber()">Change
              Number</a>
          </div>

          <button type="submit" id="otp_verify_btn" class="submit-button verify-otp-submit-btn">Verify & Submit</button>
        </form>
      </div>

      <!-- Success Screen -->
      <div *ngIf="isThanksVisible" class="success-screen thanks-view-screen">
        <div class="success-icon confirmation-icon">&#10004;</div>
        <h3 class="modal-heading">Thank You!</h3>
        <p class="modal-subheading">Our investment expert will contact you shortly.</p>
        <button class="submit-button done-button" (click)="closeLeadModal()">Done</button>
      </div>

    </div>
  </div>

  <!-- Mobile Sticky CTA Footer (Only visible on mobile scroll) -->
  <div class="mobile-sticky-cta-container" [class.show]="isStickyCTA" (click)="openLeadModal()">
    <button class="mobile-sticky-cta-btn">
      Get a FREE Portfolio Review <span class="arrow">&gt;</span>
    </button>
  </div>
</div>